import { GRAY_100 } from 'ui-kit/GlobalStyle/colors';
import styled from 'styled-components';

export const P = styled.p`
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: ${GRAY_100};
`;
